module.exports = __webpack_public_path__ + "static/media/blackFriday_lg.c23c1089.png";